import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useDeleteSubscriptionItemsMutation} from '../hooks/useSubscriptionItemsQuery';

interface DeleteRecordButtonProps {
    selectedIds: string[];
    onDeleteComplete?: () => void;
}

/**
 * Batch delete through the shared confirmation button — never a bare delete
 * (§2, DELETE_FUNCTIONALITY_PATTERN).
 *
 * FNP-918: takes the mutation directly rather than the whole list hook. The
 * old version called `useSubscriptionItems(customerId)`, which mounted a
 * SECOND infinite query for the same list purely to reach `deleteRecords` — a
 * duplicate fetch on every render of the header. It also needed the route
 * param for that; `deleteSubscriptionItem` takes the item id alone, so this
 * button no longer depends on the route at all.
 *
 * `onDeleteComplete` clears the selection. That is not cosmetic now that
 * selection lives in the store: without it the deleted ids stay selected and
 * the next confirm targets records that no longer exist.
 */
export const DeleteRecordButton = ({
                                       selectedIds,
                                       onDeleteComplete,
                                   }: DeleteRecordButtonProps) => {

    const deleteMutation = useDeleteSubscriptionItemsMutation();

    const disabled = selectedIds.length === 0 || deleteMutation.isPending;

    return (
        <DeleteRecordsConfirmationButton
            disabled={disabled}
            recordIdsLength={selectedIds.length}
            handleConfirm={() => {
                deleteMutation.mutate(selectedIds, {
                    onSuccess: () => onDeleteComplete?.(),
                });
            }}
        />
    );
};
